import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { XCircle, AlertTriangle } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import React from "react";

export function PaymentFailed() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const errorMessage = searchParams.get("error_message");
  const paymentIntentId = searchParams.get("payment_intent");

  const getErrorMessage = () => {
    if (errorMessage) {
      return errorMessage;
    }
    return "Your payment could not be processed. Please try again or use a different payment method.";
  };

  return (
    <div className="container mx-auto p-6 flex items-center justify-center min-h-[60vh]">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <XCircle className="h-16 w-16 mx-auto mb-4 text-destructive" />
          <CardTitle>Payment Failed</CardTitle>
          <CardDescription>We couldn't process your payment</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert variant="destructive">
            <AlertTriangle className="h-4 w-4" />
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>{getErrorMessage()}</AlertDescription>
          </Alert>

          {paymentIntentId && (
            <div className="bg-muted p-3 rounded-lg">
              <p className="text-xs text-muted-foreground">Payment Intent ID</p>
              <p className="text-sm font-mono">{paymentIntentId}</p>
            </div>
          )}

          <div className="space-y-2">
            <h3 className="font-semibold text-sm">Common reasons for payment failure:</h3>
            <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside">
              <li>Insufficient funds</li>
              <li>Incorrect card details</li>
              <li>Card expired or blocked</li>
              <li>Bank declined the transaction</li>
            </ul>
          </div>

          <div className="flex flex-col gap-2">
            <Button onClick={() => navigate("/manage-organisation/billing/overview")} className="w-full">
              Try Again
            </Button>
            <Button
              onClick={() => navigate("/manage-organisation/billing/overview")}
              variant="outline"
              className="w-full"
            >
              Update Payment Method
            </Button>
            <Button onClick={() => navigate("/support")} variant="ghost" className="w-full">
              Contact Support
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
